/* Project Import will be here */
import { getErrorObject } from "../../utilities/utils";
import { getOrderSummaryQtyListApi } from "services/orders";
import { IOrderSummaryDetailsParams } from "models/orderModels";
import Constants from "utilities/appConstants";
/* Project Import will be here */

export const types = {
    ORDER_SUMMARY_QTY_REQUEST: "orderSummaryQty/orderSummaryQtyRequest",
    ORDER_SUMMARY_QTY_SUCCESS: "orderSummaryQty/orderSummaryQtySuccess",
    ORDER_SUMMARY_QTY_FAILURE: "orderSummaryQty/orderSummaryQtyFailure",
};

let initialState = {
    isLoading: false,
    levelCode: "",
    data: [],
    error: null
};

export const orderSummaryQty = (state = initialState, action) => {
    switch (action.type) {
        case types.ORDER_SUMMARY_QTY_REQUEST:
            return { ...state, isLoading: true };
        case types.ORDER_SUMMARY_QTY_SUCCESS:
            return { ...state, ...action.payload, error: null, isLoading: false };
        case types.ORDER_SUMMARY_QTY_FAILURE:
            return { ...state, isLoading: false, error: action.payload.error };
        default:
            return state;
    }
};

/* Get order summary qty list to show in the card */
export const getOrderSummaryQtyList = (selectedFilterLevelCode, pageType) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.ORDER_SUMMARY_QTY_REQUEST });
        try {

            const requestParam: IOrderSummaryDetailsParams = {
                filterLevelCode: selectedFilterLevelCode,
                NeedSalesReturn: (pageType === Constants.SALES_RETURN_SUMMARY) ? true : false
            };

            const response = await getOrderSummaryQtyListApi(requestParam);

            dispatch({
                type: types.ORDER_SUMMARY_QTY_SUCCESS,
                payload: {
                    levelCode: response.data.Data.LevelCode,
                    data: response.data.Data.Items
                }
            });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.ORDER_SUMMARY_QTY_FAILURE,
                payload: { error: message }
            });
        }
    }
};